<nav #navbar class="navbar navbar-expand-lg navbar-transparent">
  <div class="container-fluid">
    <div class="navbar-wrapper">
      <div class="navbar-minimize">
        <button mat-raised-button (click)="minimizeSidebar()" class="btn btn-just-icon btn-white btn-fab btn-round">
          <i class="material-icons text_align-center visible-on-sidebar-regular">more_vert</i>
          <i class="material-icons design_bullet-list-67 visible-on-sidebar-mini">view_list</i>
        </button>
      </div>
      <span class="navbar-brand">{{ currentTitle$ | async }}</span>
    </div>
    <button #navbarToggler mat-button class="navbar-toggler btn-no-ripple" type="button" (click)="sidebarToggle()">
      <span class="sr-only">Toggle navigation</span>
      <span class="navbar-toggler-icon icon-bar"></span>
      <span class="navbar-toggler-icon icon-bar"></span>
      <span class="navbar-toggler-icon icon-bar"></span>
    </button>
    <div class="collapse navbar-collapse justify-content-end" id="navigation">
      <ul class="navbar-nav">
        <li class="nav-item">
          <button
            mat-icon-button
            class="nav-link text-start"
            type="button"
            [matMenuTriggerFor]="userMenu"
            aria-label="Menú de cuenta">
            <mat-icon aria-hidden="true" class="m-0">power_settings_new</mat-icon>
          </button>

          <mat-menu
            #userMenu="matMenu"
            xPosition="before"
            yPosition="below"
            [overlapTrigger]="false">
            <!-- <button mat-menu-item type="button" (click)="changePassword()">Cambiar contraseña</button> -->
            <button mat-menu-item type="button" (click)="onLogOut()">Cerrar sesión</button>
          </mat-menu>
        </li>
      </ul>
    </div>
  </div>
</nav>
